export const AppLightbox = {
  hide: (el, s) => !s.root.lightbox,
  position: 'fixed',
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  zIndex: '200',
  flow: 'y',
  align: 'center center',
  background: 'black.85',
  cursor: 'pointer',

  tabindex: '0',
  onKeyDown: (e, el, s) => {
    if (e.key === 'Escape' && s.root.lightbox) {
      s.root.update({ lightbox: null })
    }
  },
  onCreate: (el) => {
    if (el.node) el.node.focus()
  },

  onClick: (e, el, s) => {
    if (e.target === el.node) {
      s.root.update({ lightbox: null })
    }
  },

  CloseBtn: {
    tag: 'button',
    type: 'button',
    position: 'absolute',
    top: 'A',
    right: 'A',
    padding: 'Z',
    round: 'Z',
    background: 'white.15',
    borderWidth: '0',
    color: 'white',
    cursor: 'pointer',
    fontSize: 'B',
    fontWeight: '300',
    lineHeight: '1',
    ':hover': { background: 'white.3' },
    'aria-label': 'Close',
    text: '\u2715',
    onClick: (e, el, s) => {
      e.stopPropagation()
      s.root.update({ lightbox: null })
    }
  },

  Image: {
    tag: 'img',
    hide: (el, s) => !(s.root.lightbox?.mime || '').startsWith('image/'),
    maxWidth: '90vw',
    maxHeight: '85vh',
    objectFit: 'contain',
    round: 'Z',
    cursor: 'default',
    src: (el, s) => s.root.lightbox?.url || '',
    alt: (el, s) => s.root.lightbox?.name || 'preview',
    onClick: (e) => e.stopPropagation()
  },

  Video: {
    tag: 'video',
    hide: (el, s) => !(s.root.lightbox?.mime || '').startsWith('video/'),
    maxWidth: '90vw',
    maxHeight: '85vh',
    round: 'Z',
    cursor: 'default',
    src: (el, s) => s.root.lightbox?.url || '',
    controls: 'true',
    autoplay: 'true',
    onClick: (e) => e.stopPropagation()
  },

  FileName: {
    position: 'absolute',
    bottom: 'A',
    left: '50%',
    transform: 'translateX(-50%)',
    color: 'white.7',
    fontSize: 'Z2',
    textAlign: 'center',
    pointerEvents: 'none',
    text: (el, s) => s.root.lightbox?.name || ''
  }
}
